


































































export default function (Component) {
  Component.options.__source = "src/views/system/area/componnets/SelectArea/SelectArea.vue"
}
